import { errorActions } from './error';
import { userEntityFiltersActions } from './user_entity_filters';
import { filterActions } from './filter';
import { sharedPagesActions } from './shared_pages';
import { catalogMailingListsConstants } from '../constants/catalog_mailing_lists';
import { imprintsService } from '../services/imprints';
import { artistsService } from '../services/artists';
import { productsService } from '../services/products';
import { projectsService } from '../services/projects';
import { tracksService } from '../services/tracks';

import { catalogMailingListsService } from '../services/catalog_mailing_lists';
import { mailingListsFormatter } from '../formatters/mailing_lists';
import { find } from 'lodash';

export const catalogMailingListsActions = {
	getCatalogMailingLists,
	getCatalogMailingListsByRecipient,
	getCatalogMailingListByEntityFilter,
	getCatalogMailingListDetails,
	getCatalogMailingListRecipients,
	addCatalogMailingList,
	editCatalogMailingList,
	deleteCatalogMailingList,
	addRecipient,
	deleteRecipient,
	resendInvitation
};

function getCatalogMailingListByEntityFilter(entityFilter, useCache = true) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return dispatch(getCatalogMailingLists(useCache))
			.then(
				catalogMailingLists => {
					const catalogMailingList = find(catalogMailingLists, list=>list.user_filter_id == entityFilter);
					if(catalogMailingList) {
						dispatch(success(catalogMailingList.id, catalogMailingList));
					}
					else {
						dispatch(success(null));
					}
					return catalogMailingList;
				},
				error => {
					dispatch(failure('error'))
				}
			);
 
	};

	function request() { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_REQUEST } }
	function success(id, catalogMailingList) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_SUCCESS, id, catalogMailingList } }
	function failure(error) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_FAILURE, error } }
}

function getCatalogMailingLists(useCache = false) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const { catalogMailingLists } = getState().catalogMailingLists;
		if(useCache && catalogMailingLists) {
			dispatch(success(catalogMailingLists));
			return Promise.resolve(catalogMailingLists);
		}
		return Promise.all([
			catalogMailingListsService.getCatalogMailingLists(),
			dispatch(userEntityFiltersActions.getUserEntityFilters(true)),
			dispatch(filterActions.getFilters(true))
			
		])
			.then(
				([catalogMailingLists, filters, globalFilters]) => {
					const data = mailingListsFormatter.formatCatalogMailingLists(catalogMailingLists, filters, globalFilters);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_REQUEST } }
	function success(catalogMailingLists) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_SUCCESS, catalogMailingLists } }
	function failure(error) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_FAILURE, error } }
}

function getCatalogMailingListDetails(id) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		return catalogMailingListsService.getCatalogMailingListDetails(id, globalFilter)
			.then(
				catalogMailingList => {
					catalogMailingList = mailingListsFormatter.formatCatalogMailingList(catalogMailingList);
					dispatch(success(id, catalogMailingList));
					return catalogMailingList;
				},
				error => {
					dispatch(failure('error'))
				}
			);
 
	};

	function request() { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_REQUEST } }
	function success(id, catalogMailingList) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_SUCCESS, id, catalogMailingList } }
	function failure(error) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_FAILURE, error } }
}

function getCatalogMailingListRecipients(id) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return catalogMailingListsService.getCatalogMailingListRecipients(id)
			.then(
				recipients => {
					recipients = mailingListsFormatter.formatMailingListRecipients(recipients);
					dispatch(success(id, recipients));
					return recipients;
				},
				error => {
					dispatch(failure('error'))
				}
			);
 
	};

	function request() { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_REQUEST } }
	function success(id, recipients) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_SUCCESS, id, recipients } }
	function failure(error) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_FAILURE, error } }
}


function addCatalogMailingList(payload, formattedParams) {
	const { baseEntity, params, globalFilter, fields, vendorFields } = payload;
	return ( dispatch, getState ) => {
		const requestPayload = mailingListsFormatter.formatNewCatalogMailingList(payload, formattedParams);
		return catalogMailingListsService.addCatalogMailingList(requestPayload)
			.then(
				catalogMailingList => { 
					dispatch(success(catalogMailingList));
					dispatch(errorActions.setSuccessMessage('Notification Saved'))
					return catalogMailingList;
				},
				error => {
					dispatch(failure())
					dispatch(errorActions.setErrorMessage('Error Saving Notification'))
				}
			);			
	}
	function request() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_REQUEST } }
	function success() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_SUCCESS } }
	function failure() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_FAILURE } }

}

function editCatalogMailingList(payload, formattedParams, id) {
	return ( dispatch, getState ) => {
		const requestPayload = mailingListsFormatter.formatNewCatalogMailingList(payload, formattedParams);
		return catalogMailingListsService.editCatalogMailingList(requestPayload, id)
			.then(
				catalogMailingList => { 
					dispatch(success(catalogMailingList));
					dispatch(errorActions.setSuccessMessage('Notification Saved'))
					return catalogMailingList;
				},
				error => {
					dispatch(failure())
					dispatch(errorActions.setErrorMessage('Error Saving Notification'))
				}
			);			
	}

	function request() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_REQUEST } }
	function success() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_SUCCESS } }
	function failure() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_FAILURE } }

}

function deleteCatalogMailingList(id) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return catalogMailingListsService.deleteCatalogMailingList(id)
			.then(
				catalogMailingList => {
					dispatch(success());
					return dispatch(catalogMailingListsActions.getCatalogMailingLists())
					dispatch(errorActions.setSuccessMessage('Notification Removed'))
				},
				error => {
					dispatch(failure())
					dispatch(errorActions.setErrorMessage('Error Saving Notification'))
				}
			);
 
	};
	function request() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_REQUEST } }
	function success() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_SUCCESS } }
	function failure() { return { type: catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_FAILURE } }

}

function addRecipient(email, catalogMailingListID) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return catalogMailingListsService.addRecipient(email, catalogMailingListID)
			.then(
				result => {
					dispatch(success());
					return true;
				},
				error => {
					dispatch(failure())
				}
			);
	};

	function request() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_REQUEST } }
	function success(channel) { return { type: catalogMailingListsConstants.ADD_RECIPIENT_SUCCESS, channel } }
	function failure() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_FAILURE} }
}


function deleteRecipient(id, catalogMailingListID) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return catalogMailingListsService.deleteRecipient(id, catalogMailingListID)
			.then(
				result => {
					dispatch(success());
					dispatch(errorActions.setSuccessMessage('Recipient Deleted'))
					return true;
				},
				error => {
					dispatch(failure())
					dispatch(errorActions.setErrorMessage('Error deleting channel'))
				}
			);
	};

	function request() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_REQUEST } }
	function success() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_SUCCESS } }
	function failure() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_FAILURE} }
}

function getCatalogMailingListsByRecipient() {
	return ( dispatch, getState ) => {
		dispatch(request());
		const currentUser = getState().user.user;        
		return catalogMailingListsService.getCatalogMailingListsByRecipient(currentUser.id)
			.then(
				catalogMailingLists => {
					const data = mailingListsFormatter.formatCatalogMailingListsByRecipient(catalogMailingLists);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_REQUEST } }
	function success(catalogMailingLists) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_SUCCESS, catalogMailingLists } }
	function failure(error) { return { type: catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_FAILURE, error } }
}

function resendInvitation(id) {
	return ( dispatch, getState ) => {
		dispatch(request());
		return catalogMailingListsService.resendInvitation(id)
			.then(
				catalogMailingList => {
					dispatch(success());
					dispatch(errorActions.setSuccessMessage('Invitation Resent'))
				},
				error => {
					dispatch(failure())
					dispatch(errorActions.setErrorMessage('Error Resending'))
				}
			);
 
	};
	function request() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_REQUEST } }
	function success() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_SUCCESS } }
	function failure() { return { type: catalogMailingListsConstants.ADD_RECIPIENT_FAILURE } }

}
